import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { paths } from '../routes';
import { clearSequence, isDialogOpen, isSequencePending, isTypingTarget, markSequenceStart } from '../utils/useCommandActions';

export function getNavigationShortcuts() {
  return [
    { name: 'Track', hotkey: 'g>t', link: '/Track/Index' },
    { name: 'New Quote', hotkey: 'g>q', link: '/Quote/Index' },
    { name: 'Drivers', hotkey: 'g>d', link: '/Assets/Drivers' },
    { name: 'Vehicles', hotkey: 'g>v', link: '/Assets/Vehicles' },
    { name: 'Customers', hotkey: 'g>c', link: paths.Customers },
    { name: 'Invoice Listing', hotkey: 'g>i', link: paths.InvoiceListing },
    { name: 'Service Exceptions', hotkey: 'g>s', link: paths.ServiceExceptions },
  ];
}

const NavigationShortcuts = (): null => {

  const history = useHistory();

  useEffect(() => {
    // react-hotkeys-hook sequences share one key buffer per hook call, so only
    // the first of several sequences can ever complete - dispatch them manually
    const handleSequence = (event: KeyboardEvent) => {
      if (isTypingTarget(event) || isDialogOpen()) return;

      if (event.key === 'g' && !event.ctrlKey && !event.metaKey && !event.altKey) {
        markSequenceStart();
        return;
      }

      if (event.key === 'Shift' || event.key === 'Control' || event.key === 'Alt' || event.key === 'Meta') return;

      if (!isSequencePending()) return;

      const shortcut = getNavigationShortcuts().find(s => s.hotkey === `g>${event.key.toLowerCase()}`);
      clearSequence();
      if (shortcut) {
        event.preventDefault();
        history.push(shortcut.link);
      }
    };
    window.addEventListener("keydown", handleSequence);
    return () => window.removeEventListener("keydown", handleSequence);
  }, [history]);

  return null;
}

export default NavigationShortcuts;
